import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default class cajaTextoBusqueda extends React.Component {

    componentDidUpdate = () => {
        this.validarAcciones();
    };

    validarAcciones = () => {
        const { id, attributes } = this.props;
        const component = this.refs[id];
        if (attributes.focus)
            component.focus();
    };

    handleFocus = (event) => event.target.select();

    render() {
        const { id, label, type, value, col, attributes, onChangeInput, onKeyPress, onClick, onBlur, } = this.props;
        const readOnlyAttr = attributes.readOnly ? { readOnly: "readOnly" } : {};
        const keyPressAttr = onKeyPress ? { onKeyPress: onKeyPress } : {};
        const maxLength = attributes.maxLength ? attributes.maxLength : "";
        const min = attributes.min ? attributes.min : "";
        const max = attributes.max ? attributes.max : "";
        const stilo = {
            display: !!attributes.hidden ? attributes.hidden : "unset",
        };
        const onblur = onBlur ? onBlur : () => { };
        const stiloDiv = attributes.readOnlyBoton ? { "pointer-events": "none" } : { cursor: 'pointer' };

        return (
            <div className={`col-xs-12 col-sm-${col} col-md-${col} col-lg-${col}`} style={stilo}>
                <div className="form-group">
                    <label htmlFor={id}>{label}</label>
                    <div className="row">
                        <div className="col-12">
                            <div class="input-group mb-3">
                                <input type={type}
                                    className="form-control"
                                    onChange={onChangeInput}
                                    name={id}
                                    id={id}
                                    ref={id}
                                    maxLength={maxLength}
                                    {...readOnlyAttr}
                                    {...keyPressAttr}
                                    value={value}
                                    min={min}
                                    max={max}
                                    onFocus={this.handleFocus}
                                    onBlur={onblur}
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text" onClick={() => onClick(id)} style={stiloDiv}>
                                        <FontAwesomeIcon icon={faSearch} size={2} />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};
